import { Component, Prop, Inject, Watch } from 'vue-property-decorator';
import Vue2Filters from 'vue2-filters';
import type { INivel } from '@/shared/insaculacion/entity-commons/entity.factory';
import { EstadoRevision } from '@/shared/model/enumerations/estado-revision.model';
import { mixins } from 'vue-class-component';
import { mapGetters, mapMutations } from 'vuex';
import RevisionMixin from '../mixins/revision-mixin';
import { Solicitud } from '@/shared/model/solicitud.model';
import SolucionMixin from '../mixins/solucion-mixin';
import VigenciasSniComponent from '@/components/expediente-persona/vigencias-sni/vigencias-sni.vue';
import HomeMenuComponent from '@/components/home-menu/home-menu.component';
import { TipoRevision } from '@/shared/model/enumerations/tipo-revision.model';

@Component({
  components: {
    'vigencias-sni': VigenciasSniComponent,
  },
  mixins: [Vue2Filters.mixin],
  computed: {
    ...mapGetters([
      'dictamen',
      'evaluacion',
      'revisorSeleccionado',
      'resultadoGralCualitativoFinal',
      'valoracionesCualitativas',
      'nivelEvaluacion1',
      'sumaValoresCualitativos1',
      'resultadoGralCualitativo1',
      'valido',
      'confirmaNivelSugerido',
      'segundaOportunidadUsada',
      'evaluacionEmeGuardada1',
      'valoracionesCualitativasEme',
      'nivelEvaluacion2',
      'sumaValoresCualitativos2',
      'resultadoGralCualitativo2',
      'sumaValoresCualitativosFinal',
      'resumen',
      'segundaOportunidadActiva',
      'esExcepcion',
      'nivelExcepcion',
      'justificacionExcepcion',
      'evaluacionEmeGuardadaFinal',
      'evaluacionGuardadaFinal',
      'evaluacionGuardada1',
    ]),
  },
  methods: {
    ...mapMutations([
      'setDictamen',
      'setEvaluacion',
      'setResultadoGralCualitativoFinal',
      'setValoracionesCualitativas',
      'setNivelEvaluacion1',
      'setSumaValoresCualitativos1',
      'setResultadoGralCualitativo1',
      'setValido',
      'setConfirmaNivelSugerido',
      'setSegundaOportunidadUsada',
      'setEvaluacionEmeGuardada1',
      'setValoracionesCualitativasEme',
      'setNivelEvaluacion2',
      'setSumaValoresCualitativos2',
      'setResultadoGralCualitativo2',
      'setSumaValoresCualitativosFinal',
      'setResumen',
      'setSegundaOportunidadActiva',
      'setEsExcepcion',
      'setNivelExcepcion',
      'setJustificacionExcepcion',
      'setEvaluacionEmeGuardadaFinal',
      'setEvaluacionGuardadaFinal',
      'setEvaluacionGuardada1',
    ]),
  },
})
export default class EvaluacionIndividualEmerito2026Component extends mixins(RevisionMixin, SolucionMixin, HomeMenuComponent) {
  @Prop({ required: true })
  public revision;

  @Prop({ required: true })
  public solicitud: Solicitud;

  public plenariaId = '';

  public readonly evaluacion: INivel;

  public aceptada = EstadoRevision.ACEPTADA;
  public revisada = EstadoRevision.REVISADA;

  /* NUEVO 2026 */
  public confirmaNivelSugerido = '';
  public mostrarFormularioExcepcion = false;
  public justificacionExcepcion = '';
  public segundaOportunidadUsada = false;
  public segundaOportunidadActiva = false;
  public resaltarTablaSegundaOportunidad = false;
  public evaluacionEmeGuardada1 = false;
  public evaluacionEmeGuardada2 = false;

  public mostrarAlertaSemaforo = false;
  public mensajeAlertaSemaforo = '';
  public timeoutAlertaSemaforo: any = null;
  public nivelExcepcionSeleccionado: any = null;
  public mostrarAlertConfirmacion = false;
  public evaluacionEmeGuardadaFinal = false;

  /* NUEVO 2026 */
  public opcionesValoracionCualitativa: string[] = ['Muy baja', 'Baja', 'Moderada', 'Alta', 'Muy alta'];

  /**
   * Guarda las opciones seleccionadas en la tabla cualitativa.
   * Cada campo almacena solo la descripción para que funcione el v-model.
   *
   * Ejemplo:
   * relevante: "Alta"
   */
  public valoracionesCualitativasEme = {
    relevante: '',
    pertinente: '',
    sostenida: '',
    diversa: '',

    comprometidoFormacion: '',
    colaborativo: '',
    constante: '',

    inclusivaGratuita: '',
    comprensible: '',
  };

  /**
   * Guarda las valoraciones recuperadas con descripción y valor.
   * Sirve para consultar el dato completo después de recuperar la información.
   *
   */
  public valoracionesCualitativasCompletas: any = {};

  public nivelEmeritos: INivel = { id: '6', nombre: 'Investigador Nacional Emérito' };

  public noAprobado: INivel = { id: '5', nombre: 'No aprobado' };

  public nivelEvaluacion1: INivel = {};

  public nivelEvaluacion2: INivel = {};

  public boldFields = false;

  /**
   * Puntajes generales para cada opción de valoración cualitativa.
   * Se usan cuando no existe una regla especial para el campo.
   */
  public puntajesValoracionDefault: any = {
    'Muy baja': 1,
    Baja: 2,
    Moderada: 3,
    Alta: 4,
    'Muy alta': 5,
  };

  public deshabilitarSecciones = false;

  /**
   * Puntajes especiales para ciertas cualidades.
   *
   * Estos valores sobrescriben el puntaje general cuando una cualidad
   * necesita una regla diferente según el nivel.
   */
  public puntajesValoracionEspeciales: any = {
    diversa: {
      E: {
        'Muy baja': 0,
        Baja: 0,
        Moderada: 1,
        Alta: 2,
        'Muy alta': 3,
      },
    },
  };

  /**
   * Mutación del store para guardar la evaluación
   */
  setEvaluacion!: (evaluacion: INivel) => void;

  setDictamen!: (dictamen: any) => void;

  mounted(): void {
    this.get();
    this.getDefinicionRevision(this.solicitud.solucionId);
    this.getEvaluacionIdPlenariaIndividual();
  }

  /**
   * Carga inicial del componente
   *
   * @memberof EvaluacionIndividualComponet
   */
  public get(): void {
    if (this.solicitud && this.revision) {
      const respuesta: any = this.revision?.respuesta;
      const properties: any = respuesta?.properties || respuesta || {};

      if (properties?.evaluacion) {
        this.recomendado = properties.evaluacion;
      } else if (this.evaluacion?.id) {
        this.recomendado = this.evaluacion;
      }

      if (properties?.clonado && properties?.evaluacionEmeGuardadaFinal) {
        this.clonado = properties.clonado;
        this.mostrarComponente();
      }

      if (properties?.evaluacionEmeGuardadaFinal) {
        this.evaluacionEmeGuardadaFinal = properties?.evaluacionEmeGuardadaFinal;
      }

      /**
       * Carga las valoraciones cualitativas guardadas para que
       * la tabla quede pintada al cambiar de sección o recargar.
       */
      if (properties?.valoracionesCualitativasEme) {
        this.cargarValoracionesCualitativasGuardadas(properties.valoracionesCualitativasEme);
      }

      /**
       * Si la evaluación ya fue guardada, se restaura el estado
       * para que todo quede congelado y con los datos visibles.
       */
      if (properties?.evaluacionEmeGuardada1) {
        this.evaluacionEmeGuardada1 = true;
        this.confirmaNivelSugerido = properties?.confirmaNivelSugerido || '';
        this.mostrarFormularioExcepcion = !!properties?.esExcepcion;
        this.justificacionExcepcion = properties?.justificacionExcepcion || '';
        this.segundaOportunidadUsada = !!properties?.segundaOportunidadUsada;
        this.segundaOportunidadActiva = !!properties?.segundaOportunidadActiva;
        this.nivelExcepcionSeleccionado = properties?.nivelExcepcion || null;
        this.nivelEvaluacion1 = properties?.nivelEvaluacion1 || null;
        this.evaluacionEmeGuardadaFinal = properties?.evaluacionEmeGuardadaFinal || false;
      } else {
        this.evaluacionEmeGuardada1 = false;
        this.confirmaNivelSugerido = '';
        this.mostrarFormularioExcepcion = false;
        this.justificacionExcepcion = '';
        this.segundaOportunidadUsada = false;
        this.segundaOportunidadActiva = false;
        this.nivelExcepcionSeleccionado = null;
      }
    }
  }

  /**
   * Guarda el nivel recomendado de SNI
   *
   * @memberof EvaluacionIndividualComponet
   */
  public guardarEvaluacion1(): void {
    if (this.evaluacionBloqueada) {
      return;
    }

    let datosEnviar = {};

    this.setDictamen({});

    const valoracionesParaGuardar = this.valoracionesCualitativasParaGuardar;
    const evaluacionSugerida = this.recomendado;

    this.setEvaluacion(this.nivelEvaluacion1);

    if (this.evaluacionIndividual) {
      datosEnviar = {
        evaluacion: evaluacionSugerida,
        nivelEvaluacion1: this.nivelEvaluacion1,
        sumaValoresCualitativos1: this.sumaValoresCualitativos,
        resultadoGralCualitativo1: this.resultadoGralCualitativo,
        dictamen: {},
        valido: false,

        confirmaNivelSugerido: this.confirmaNivelSugerido,
        segundaOportunidadUsada: this.segundaOportunidadUsada,

        evaluacionEmeGuardada1: true,

        valoracionesCualitativasEme: valoracionesParaGuardar,
      };
    }

    this.guardaEvaluacion(datosEnviar);

    this.evaluacionEmeGuardada1 = true;
  }

  /**
   * Muestra una alerta temporal en pantalla con el mensaje recibido.
   */
  public mostrarMensajeAlertaSemaforo(mensaje: string): void {
    this.mensajeAlertaSemaforo = mensaje;
    this.mostrarAlertaSemaforo = true;

    if (this.timeoutAlertaSemaforo) {
      clearTimeout(this.timeoutAlertaSemaforo);
    }

    this.timeoutAlertaSemaforo = setTimeout(() => {
      this.mostrarAlertaSemaforo = false;
    }, 4000);
  }

  /**
   * Obtiene la información Rizoma de la solicitud actual.
   */
  public get solicitudRizomaActual(): any {
    const solicitudAny: any = this.solicitud;

    return solicitudAny?.SOLICITUD_RIZOMA || solicitudAny?.properties?.SOLICITUD_RIZOMA || {};
  }

  /**
   * Obtiene el id del tipo de perfil actual.
   */
  public get tipoPerfilActualId(): string {
    return this.solicitudRizomaActual?.tipoPerfil?.id || '';
  }

  /**
   * Obtiene el id del nivel sugerido actual.
   */
  public get nivelSugeridoActualId(): string {
    const respuesta: any = this.revision?.respuesta;
    const properties: any = respuesta?.properties || respuesta || {};

    return this.recomendado?.id || properties?.evaluacion?.id || '';
  }

  /**
   * Limpia la valoración cualitativa capturada.
   * Se usa cuando el usuario tiene una segunda oportunidad para evaluar.
   */
  public limpiarValoracionCualitativa(): void {
    this.valoracionesCualitativasEme = {
      relevante: '',
      pertinente: '',
      sostenida: '',
      diversa: '',

      comprometidoFormacion: '',
      colaborativo: '',
      constante: '',

      inclusivaGratuita: '',
      comprensible: '',
    };

    this.setEvaluacion({});
    this.setDictamen({});
  }

  /**
   * Envía al usuario de regreso a la tabla de valoración cualitativa.
   * Se usa cuando tiene una segunda oportunidad para evaluar.
   */
  private enviarUsuarioATablaCualitativa(): void {
    this.$nextTick(() => {
      const tabla = this.$refs.tablaValoracionCualitativa as HTMLElement;

      if (tabla) {
        tabla.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }

      this.resaltarTablaSegundaOportunidad = true;

      setTimeout(() => {
        this.resaltarTablaSegundaOportunidad = false;
      }, 3000);
    });
  }

  /**
   * Valida si todas las valoraciones cualitativas ya fueron capturadas.
   * Regresa true solo si todos los campos tienen una opción seleccionada.
   */
  public get todasValoracionesCapturadasEmeritos(): boolean {
    const valoraciones: any = this.valoracionesCualitativasEme;

    return Object.keys(valoraciones).every(key => !!valoraciones[key]);
  }

  /**
   * Obtiene la columna de puntajes cualitativos según el nivel sugerido.
   */
  public get columnaNivelCualitativo(): string {
    const respuesta: any = this.revision?.respuesta;
    const properties: any = respuesta?.properties || respuesta || {};

    const nivelId = String(properties?.evaluacion?.id || this.recomendado?.id || '');

    const columnas: any = {
      '6': 'E', // EMERITOS
    };

    return columnas[nivelId] || 'E';
  }

  /**
   * Obtiene el puntaje numérico según la valoración seleccionada.
   * Ejemplo: "Alta" = 4, "Muy alta" = 5.
   * También revisa si existe una regla especial para ciertos campos.
   */
  public obtenerPuntajeCualitativo(campo: string, descripcion: string): number | null {
    if (!campo || !descripcion) {
      return null;
    }

    const columna = this.columnaNivelCualitativo;

    const puntajeEspecial = this.puntajesValoracionEspeciales?.[campo]?.[columna]?.[descripcion];

    if (puntajeEspecial !== undefined) {
      return puntajeEspecial;
    }

    return this.puntajesValoracionDefault?.[descripcion] ?? null;
  }

  /**
   * Prepara las valoraciones cualitativas para guardarlas.
   * Convierte cada selección en un objeto con descripción y valor.
   */
  public get valoracionesCualitativasParaGuardar(): any {
    const resultado: any = {};

    Object.keys(this.valoracionesCualitativasEme).forEach(campo => {
      const descripcion = ((this.valoracionesCualitativasEme as any)[campo] || '').trim();

      resultado[campo] = {
        descripcion: descripcion,
        valor: this.obtenerPuntajeCualitativo(campo, descripcion),
      };
    });

    return resultado;
  }

  /**
   * Carga las valoraciones cualitativas guardadas en la revisión.
   *
   * Pero también conservamos descripcion y valor en:
   * valoracionesCualitativasCompletas
   */
  public cargarValoracionesCualitativasGuardadas(valoracionesGuardadas: any): void {
    if (!valoracionesGuardadas) {
      return;
    }

    const valoracionesPantalla: any = {};
    const valoracionesCompletas: any = {};

    Object.keys(this.valoracionesCualitativasEme).forEach(campo => {
      const valorGuardado = valoracionesGuardadas[campo];

      let descripcion = '';
      let valor: number | null = null;

      if (valorGuardado && typeof valorGuardado === 'object') {
        descripcion = valorGuardado.descripcion || '';
        valor = valorGuardado.valor ?? this.obtenerPuntajeCualitativo(campo, descripcion);
      } else {
        descripcion = valorGuardado || '';
        valor = this.obtenerPuntajeCualitativo(campo, descripcion);
      }

      valoracionesPantalla[campo] = descripcion;

      valoracionesCompletas[campo] = {
        descripcion,
        valor,
      };
    });

    this.valoracionesCualitativasEme = {
      ...this.valoracionesCualitativasEme,
      ...valoracionesPantalla,
    };

    this.valoracionesCualitativasCompletas = {
      ...this.valoracionesCualitativasCompletas,
      ...valoracionesCompletas,
    };
  }

  get sumaValoresCualitativos(): number {
    const datos = this.valoracionesCualitativasParaGuardar as unknown;

    if (!datos) return 0;

    return Object.values(datos).reduce((total, item) => {
      return total + item.valor;
    }, 0);
  }

  get resultadoGralCualitativo(): string {
    const suma = this.sumaValoresCualitativos;

    if (suma >= 34) {
      return 'Muy alto';
    }

    if (suma >= 28) {
      return 'Alto';
    }

    if (suma >= 22) {
      return 'Moderado';
    }

    if (suma >= 16) {
      return 'Bajo';
    }

    return 'Muy bajo';
  }

  @Watch('todasValoracionesCapturadasEmeritos')
  private calculaNivel(): void {
    if (!this.todasValoracionesCapturadasEmeritos) return;

    if (this.evaluacionEmeGuardada1 === false && this.segundaOportunidadActiva === false) {
      this.nivelEvaluacion1 = this.sumaValoresCualitativos >= 28 ? this.nivelEmeritos : this.noAprobado;
      this.guardarEvaluacion1();
    } else if (this.evaluacionEmeGuardada2 === false && this.segundaOportunidadActiva === true && this.segundaOportunidadUsada === false) {
      this.nivelEvaluacion2 = this.sumaValoresCualitativos >= 28 ? this.nivelEmeritos : this.noAprobado;
      this.guardarEvaluacion2();
    }
  }

  public guardarEvaluacionSi(): void {
    const valoracionesParaGuardar = this.valoracionesCualitativasParaGuardar;
    this.confirmaNivelSugerido = 'SI';

    let datosEnviar = {};

    datosEnviar = {
      evaluacion: this.nivelEvaluacion1,
      nivelEvaluacion1: this.nivelEvaluacion1,
      sumaValoresCualitativosFinal: this.sumaValoresCualitativos,
      resultadoGralCualitativoFinal: this.resultadoGralCualitativo,
      valido: false,
      resumen: this.resumen,

      confirmaNivelSugerido: 'SI',
      segundaOportunidadUsada: false,
      esExcepcion: false,

      nivelExcepcion: null,

      justificacionExcepcion: null,

      evaluacionEmeGuardadaFinal: true,

      valoracionesCualitativasEme: valoracionesParaGuardar,
    };

    this.guardaEvaluacion(datosEnviar);
    (this.evaluacionEmeGuardadaFinal = true), (this.recomendado = this.nivelEvaluacion1);
    this.mostrarAlertConfirmacion = true;
  }

  public guardarEvaluacionNo(): void {
    let datosEnviar = {};

    this.segundaOportunidadUsada = false;
    this.segundaOportunidadActiva = true;

    this.confirmaNivelSugerido = 'NO';
    this.justificacionExcepcion = '';

    this.limpiarValoracionCualitativa();
    this.enviarUsuarioATablaCualitativa();

    datosEnviar = {
      valoracionesCualitativasEme: this.valoracionesCualitativasEme,
      segundaOportunidadUsada: this.segundaOportunidadUsada,
      segundaOportunidadActiva: this.segundaOportunidadActiva,
      confirmaNivelSugerido: this.confirmaNivelSugerido,
    };

    this.guardaEvaluacion(datosEnviar);
  }

  public guardarEvaluacion2(): void {
    const valoracionesParaGuardar = this.valoracionesCualitativasParaGuardar;

    let datosEnviar = {};

    datosEnviar = {
      evaluacion: this.nivelEvaluacion2,
      nivelEvaluacion2: this.nivelEvaluacion2,
      sumaValoresCualitativos2: this.sumaValoresCualitativos,
      resultadoGralCualitativo2: this.resultadoGralCualitativo,
      sumaValoresCualitativosFinal: this.sumaValoresCualitativos,
      resultadoGralCualitativoFinal: this.resultadoGralCualitativo,

      valido: false,
      resumen: this.resumen,

      segundaOportunidadUsada: true,
      segundaOportunidadActiva: false,
      esExcepcion: false,

      nivelExcepcion: null,

      justificacionExcepcion: null,

      evaluacionEmeGuardadaFinal: true,

      valoracionesCualitativasEme: valoracionesParaGuardar,
    };

    this.guardaEvaluacion(datosEnviar);
    this.recomendado = this.nivelEvaluacion2;
    this.evaluacionEmeGuardadaFinal = true;
    this.mostrarAlertConfirmacion = true;
  }

  get mostrarBotonConfirmar(): boolean {
    return this.confirmaNivelSugerido == null || this.confirmaNivelSugerido == '';
  }

  /**
   * Indica si la evaluación debe quedar bloqueada.
   * Se bloquea si ya fue guardada o si la revisión ya está revisada.
   */
  public get evaluacionBloqueada(): boolean {
    return (
      (this.evaluacionEmeGuardada1 == true && this.todasValoracionesCapturadasEmeritos) ||
      this.revision?.estado === this.revisada ||
      this.evaluacionEmeGuardadaFinal == true
    );
  }

  /**
   * Obtiene la defición evaluación
   */
  @Watch('definicionEvaluacion')
  public getEvaluacionIdPlenariaIndividual(): void {
    if (this.definicionEvaluacion) {
      for (const definicion of this.definicionEvaluacion.revisiones) {
        if (definicion.tipoRevision === TipoRevision.PLENARIA) {
          this.plenariaId = definicion.id;
        }
      }
    }

    if (this.revision?.evaluacionId === this.plenariaId) {
      this.isPleno = true;
    } else {
      this.isPleno = false;
    }
  }

  /**
   * Valida si se desea mostrar el componente
   */
  public mostrarComponente(): boolean {
    if (this.isPleno && this.clonado) {
      return true;
    } else if (!this.isPleno) {
      return true;
    } else if (this.isPleno && this.revision?.respuesta?.clonado === false) {
      return true;
    }
    return false;
  }
}
